export default {
  namespaced: true,
  state: {
    selectedClient: null,
  },
  getters: {
    hasContext: (state) => state.selectedClient !== null,
    selectedClient: (state) => state.selectedClient,
    clientRut: (state) => state.selectedClient?.rut || null,
    clientId: (state) => state.selectedClient?.id || null,
    clientDisplayName: (state) => {
      const c = state.selectedClient;
      if (!c) return '';
      return c.nombre || c.username || '';
    },
    clientInitials: (state, getters) => {
      const name = getters.clientDisplayName;
      if (!name) return '?';
      return name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();
    },
  },
  mutations: {
    SET_CLIENT(state, client) {
      state.selectedClient = client;
    },
    CLEAR_CLIENT(state) {
      state.selectedClient = null;
    },
  },
  actions: {
    setClient({ commit }, client) {
      commit('SET_CLIENT', client);
    },
    clearClient({ commit }) {
      commit('CLEAR_CLIENT');
    },
  },
};
